// utility to check a type
export const isNull = (o: any): o is null => {
  if (o === null) return true;
  return false;
};

export const isUndefined = (o: any): o is undefined => {
  if (o === undefined) return true;
  return false;
};

export const isNil = (o: any): o is undefined | null => {
  if (isUndefined(o) || isNull(o)) return true;
  return false;
};

export const isDefined = <T>(o: T | null | undefined): o is T => {
  if (isUndefined(o) || isNull(o)) return false;
  return true;
};

export const isString = (o: any): o is string => {
  if (isNil(o)) return false;
  if (typeof o === "string") return true;
  return false;
};

export const isNumber = (value: number | undefined | null): value is number => {
  if (isNil(value)) return false;
  if (Number.isFinite(value)) return true;
  return false;
};

export const isDate = (o: any) => {
  if (isNil(o)) return false;
  if (o instanceof Date) return true;
  return false;
};

export const isBoolean = (o: any) => {
  if (isNil(o)) return false;
  if (typeof o === "boolean") return true;
  return false;
};

export const isArray = (o: any): o is [] => {
  if (isNil(o)) return false;
  if (o instanceof Array) return true;
  return false;
};

export const isObject = (o: any) => {
  if (isNil(o)) return false;
  if (o instanceof Object) return true;
  return false;
};

export const isUrl = (o: any) => {
  if (!isString(o)) return false;
  try {
    const url = new URL(o);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (e) {
    return false;
  }
};

export const isEmpty = (o: any[] | string) => {
  if (isNil(o)) return true;
  if (isString(o)) return o.length === 0;
  if (isArray(o)) return o.length === 0;
  console.error(`Called isEmpty with invalid type: ${typeof o}`);
  return true;
};
